import { render, staticRenderFns } from "./EmojiSelector.vue?vue&type=template&id=06ad51cf"
import script from "./EmojiSelector.vue?vue&type=script&lang=js"
export * from "./EmojiSelector.vue?vue&type=script&lang=js"
import style0 from "./EmojiSelector.vue?vue&type=style&index=0&id=06ad51cf&prod&lang=scss&module=true"
import style1 from "./EmojiSelector.vue?vue&type=style&index=1&id=06ad51cf&prod&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports